export default __webpack_public_path__ + "static/media/404.9c14cd9d.png";